export default __webpack_public_path__ + "static/media/Sanathan_Textiles_DRHP.58733077.pdf";